import type { SignIn } from "@clerk/clerk-react";
import type { ComponentProps } from "react";

/** The Clerk appearance type, derived from the component prop (not a deep import). */
type Appearance = NonNullable<ComponentProps<typeof SignIn>["appearance"]>;

/**
 * Styles Clerk's hosted sign-in / sign-up UI to the Cendre · Mono Ink system.
 *
 * Colours are passed as `var(--token)` so they resolve live and flip with the
 * `.dark` class — no Clerk re-render on theme change. The interactive bits that
 * Clerk would otherwise tint (the primary button) are pinned to ink utilities so
 * hover/active stay monochrome instead of a computed hue.
 */
export const clerkAppearance: Appearance = {
  variables: {
    colorPrimary: "var(--ink)",
    colorBackground: "var(--paper)",
    colorText: "var(--ink)",
    colorTextSecondary: "var(--ink-muted)",
    colorInputText: "var(--ink)",
    colorInputBackground: "var(--paper)",
    colorNeutral: "var(--ink)",
    borderRadius: "var(--radius-sm)",
    fontFamily: "var(--font-sans)",
  },
  elements: {
    rootBox: "w-full",
    card: "bg-paper border border-line shadow-[var(--shadow-soft)]",
    headerTitle: "font-serif",
    formButtonPrimary: "bg-ink text-paper hover:bg-ink-strong normal-case shadow-none",
    formFieldInput: "border-line bg-paper",
    footerActionLink: "text-ink hover:text-ink-strong",
    socialButtonsBlockButton: "border-line text-ink-soft hover:bg-line-soft",
  },
};
